module.exports = __webpack_public_path__ + "img/LogoDashboard-25.b1de114d.svg";